export { default as InventoryList } from './InventoryList';
